<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.TITLE')"
      :breadcrumbs="[
        {
          text: 'Asukoha',
          disabled: true
        }
      ]"
    />
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="[
            {
              text: '#',
              align: 'start',
              sortable: false,
              value: 'ID'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.CREATED_AT'),
              align: 'start',
              sortable: false,
              value: 'CreatedAt'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.SERVICE_TIME'),
              align: 'start',
              sortable: false,
              value: 'ServiceTime'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.AMOUNT'),
              align: 'start',
              sortable: false,
              value: 'Amount'
            },
            {
              text: $vuetify.lang.t('$vuetify.EMAIL'),
              align: 'start',
              sortable: false,
              value: 'Email'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.LICENSE_PLATE'),
              align: 'start',
              sortable: false,
              value: 'LicensePlate'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.MESSAGE'),
              align: 'start',
              sortable: false,
              value: 'Message'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.STATUS'),
              align: 'start',
              sortable: false,
              value: 'Status'
            },
            {
              text: '',
              align: 'end',
              sortable: false,
              value: 'actions'
            }
          ]"
          :items="carWashDisputes"
          hide-default-footer
          :items-per-page="pageSize"
        >
          <template v-slot:item.CreatedAt="props">
            <td>{{ dateEE(props.item.CreatedAt) }}</td>
          </template>
          <template v-slot:item.ServiceTime="props">
            <td>{{ dateEE(props.item.ServiceTime) || '-' }}</td>
          </template>
          <template v-slot:item.Amount="props">
            <td>
              {{ props.item.AmountInCents / 100 || '-' }}&nbsp;{{
                props.item.Currency
              }}
            </td>
          </template>
          <template v-slot:item.Email="props">
            <td>{{ props.item.Email || '-' }}</td>
          </template>
          <template v-slot:item.Message="props">
            <td style="cursor: pointer" @click="onMessageClick(props.item)">
              <div class="text-truncate" style="max-width: 124px">
                {{ props.item.Message || '-' }}
              </div>
            </td>
          </template>
          <template v-slot:item.actions="props">
            <td class="d-flex align-center">
              <v-tooltip v-if="props.item.Status !== 'REJECTED'" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="secondary--text"
                    @click.stop="onEditDisputeClick(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{
                    $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.EDIT_DISPUTE')
                  }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="props.item.Status !== 'REJECTED'" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="error--text"
                    @click.stop="onDisputeRejectClick(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.REJECT') }}
                </span>
              </v-tooltip>
              <v-tooltip
                v-if="
                  props.item.Status !== 'REJECTED' &&
                    props.item.Status !== 'APPROVED'
                "
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="success--text"
                    @click.stop="onDisputeApproveClick(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.APPROVE') }}
                </span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:item.Status="props">
            <td>
              <span
                left
                :style="{
                  'background-color': disputeStatusColor(props.item.Status)
                }"
                class="white--text font-weight-bold caption"
                style="border-radius: 20px; padding: 4px 6px;"
              >
                {{ props.item.Status }}
              </span>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-toolbar color="transparent" class="elevation-0">
        <v-spacer></v-spacer>
        <v-btn
          fab
          color="white"
          x-small
          class="ma-2"
          :disabled="currentPageNumber === 0"
          @click="prevPage()"
        >
          <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
        </v-btn>
        <v-btn fab color="primary" class="secondary--text" x-small readonly>
          {{ currentPageNumber + 1 }}
        </v-btn>
        <v-btn
          fab
          color="white"
          x-small
          class="ma-2"
          :disabled="!nextAvailablePage || nextAvailablePage <= 0"
          @click="nextPage()"
        >
          <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-col cols="1" class="pa-0">
          <v-select
            v-model="pageSize"
            :items="[10, 30, 50, 100]"
            :label="$vuetify.lang.t('$vuetify.STATISTICS.SHOW')"
            hide-details
            @change="onPageSizeChange"
          ></v-select>
        </v-col>
      </v-toolbar>
    </v-card>

    <edit-dispute-dialog
      :visible="disputeEditDialog"
      @close="disputeEditDialog = false"
    />
    <v-dialog
      v-if="selectedDispute"
      v-model="disputeMessageDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>
          {{ $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.MESSAGE') }}
        </v-card-title>
        <v-card-text>
          {{ selectedDispute.Message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="disputeMessageDialog = false">
            {{ $vuetify.lang.t('$vuetify.CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import formatDate from '@/mixins/formatDate'
import EditDisputeDialog from '@/components/disputes/EditDisputeDialog'

export default {
  name: 'CarWashDisputes',
  components: {
    EditDisputeDialog
  },
  mixins: [formatDate],
  props: {
    placeId: String
  },
  data() {
    return {
      disputeEditDialog: false,
      disputeMessageDialog: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('disputes', [
      'carWashDisputes',
      'nextAvailablePage',
      'currentPageNumber',
      'pageSize',
      'selectedDispute'
    ]),
    currentPageNumber: {
      get() {
        return this.$store.state.disputes.currentPageNumber
      },
      set(val) {
        this.setCurrentPageNumber(val)
      }
    },
    pageSize: {
      get() {
        return this.$store.state.disputes.pageSize
      },
      set(val) {
        this.setPageSize(val)
      }
    }
  },
  mounted() {
    this.getCarWashDisputesForPlace(this.placeId)
  },
  created() {},
  methods: {
    ...mapActions('disputes', ['getCarWashDisputesForPlace']),
    ...mapMutations('disputes', [
      'setSelectedDispute',
      'setSelectedDisputeValue',
      'setCurrentPageNumber',
      'setPageSize'
    ]),
    prevPage() {
      if (this.carWashDisputes.length > 0) {
        this.currentPageNumber -= 1
        this.getCarWashDisputesForPlace(this.placeId)
      }
    },
    nextPage() {
      if (this.carWashDisputes.length !== 0) {
        this.currentPageNumber += 1
        this.getCarWashDisputesForPlace(this.placeId)
      }
    },
    onPageSizeChange() {
      this.setCurrentPageNumber(0)
      this.getCarWashDisputesForPlace(this.placeId)
    },
    disputeStatusColor(status) {
      switch (status) {
        case 'INITIATED':
          return '#009DDB'
        case 'APPROVED':
          return 'green'
        case 'REJECTED':
          return 'red'
        case 'RESOLVED':
          return 'green'
        case 'UNRESOLVED':
          return 'gray'
        default:
          break
      }
      return ''
    },
    onEditDisputeClick(dispute) {
      this.setSelectedDispute(dispute)
      this.disputeEditDialog = true
    },
    onMessageClick(dispute) {
      this.setSelectedDispute(dispute)
      this.disputeMessageDialog = true
    },
    onDisputeRejectClick(dispute) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          // eslint-disable-next-line no-console
          console.log('WILL REJECT', dispute)
        }
      })
    },
    onDisputeApproveClick(dispute) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          // eslint-disable-next-line no-console
          console.log('WILL APPROVE', dispute)
        }
      })
    }
  }
}
</script>

<style scoped>
.list {
  background: transparent;
}
</style>
